import { useDispatch } from 'react-redux';

import type { AppDispatch } from 'actions/index';

export const useAppDispatch = () => useDispatch<AppDispatch>();
